import { CommentsSection } from './comments/section.jsx';

const targets = Array.from(document.querySelectorAll('.js-comments'));
for(const target of targets)
    target.replaceWith(new CommentsSection({ category: target.dataset.category }).element);
